/** Static assets rendered on the trust-info interstitial. */
export const TRUST_INFO_ASSET = {
  HERO_IMAGE: 'https://cdn.cureskin.com/app/img/trust-info-hero.png',
  MEN_TREATED_ICON: '/assets/images/trust-info-page/icon-men-treated.png',
  IMPROVEMENT_ICON: '/assets/images/trust-info-page/icon-improvement.png',
} as const;

/** Concern key used as a fallback when the user's concern has no trust-info variant entry. */
export const DEFAULT_CONCERN_KEY = 'HAIR_LOSS';

/** Headline stat values shown on the trust-info cards, split by gender. */
export const TRUST_INFO_STAT = {
  MEN_TREATED: '20,000+',
  WOMEN_TREATED: '12,000+',
  MALE_IMPROVEMENT: '93%',
  FEMALE_IMPROVEMENT: '80%',
} as const;

/** Parse column names read from the acting user on the trust-info page. */
export const TRUST_INFO_USER_FIELD = {
  PATIENT_NAME: 'PatientName',
  GENDER: 'Gender',
  LANGUAGE_PREFERENCE: 'languagePreference',
  FACE_MAIN_CONCERN: 'FaceMainConcern',
  HAIR_MAIN_CONCERN: 'HairMainConcern',
  PRIVATE_MAIN_CONCERN: 'PrivateMainConcern',
} as const;

/** Parse column names read from the consultation session. */
export const TRUST_INFO_SESSION_FIELD = {
  PRIVATE_MAIN_CONCERN: 'PrivateMainConcern',
  CONCERN_LIST: 'concernList',
} as const;

/** Query-param keys used when navigating to/from the trust-info page. */
export const TRUST_INFO_QUERY_PARAM = {
  CLASS: 'class',
  TYPE: 'type',
  USERNAME: 'username',
  SESSION_ID: 'sessionId',
  REDIRECT_ON_BACK: 'redirectOnBack',
} as const;

/** Query-param `type` value identifying a consultation-session chat. */
export const CONSULTATION_SESSION_TYPE = 'consultationSession';

/** Broadcast event that asks the native shell / app to navigate back. */
export const NAVIGATION_BACK_EVENT = 'NAVIGATION_BACK';

/** Route the trust-info page continues to on Proceed. */
export const CHAT_V2_ROUTE = 'chatV2';

/** CleverTap `click` event name fired when the user taps Proceed. */
export const TRUST_INFO_PROCEED_EVENT_NAME = 'trust_page_proceed';
